import React, { useState } from "react";
import Select, { components } from "react-select";

const CustomValueContainer = ({ children, getValue, ...props }) => {
    const selected = getValue();
    let displayLabel = selected.length > 0 && `${selected.length} selected`;
  
    return (
      <components.ValueContainer {...props}>
        {displayLabel}
        {React.Children.map(children, (child) => (child && child.type !== components.MultiValue ? child : null))}
      </components.ValueContainer>
    );
  };

export default CustomValueContainer;